<template>
  <div>
    <div class="panel">
      <div v-if="isLoading" class="my-4 text-center">
        <scale-loader />
      </div>
      <div v-else class="flex flex-wrap">

        <div class="w-1/2 pr-4 pb-4 flex">
          <b-field label="TENANT ID" class="w-full">
            <v-input v-model="config.tenant_id" />
          </b-field>
        </div>

        <div class="w-1/2 pr-4 pb-4 flex">
          <b-field label="TENANT DOMAIN" class="w-full">
            <v-input v-model="config.tenant_domain" />
          </b-field>
        </div>

        <div class="w-1/2 pr-4 pb-4 flex">
          <b-field label="CLIENT ID" class="w-full">
            <v-input v-model="config.client_id" />
          </b-field>
        </div>

        <div class="w-1/2 pr-4 pb-4 flex">
          <b-field label="CLIENT SECRET" class="w-full">
            <v-input v-model="config.client_secret" />
          </b-field>
        </div>
      </div>

    </div>
    <div class="flex justify-end mt-4">
      <v-button 
        @click="save"
        :disabled="!config.tenant_id || !config.tenant_domain || !config.client_id || !config.client_secret" 
        :loading="sendingform"
        type="button" 
        icon="thumbs-up" 
        icon-pack="far" 
        class="mr-4">
        {{ $t('save') }}
      </v-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue"
import axios from 'axios'
import Form from 'vform'
import moment from 'moment'
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { data } from "autoprefixer";


export default {
  middleware: 'auth',
  title: 'sharepoint_config_edit',
  menuOption: '2-8',
  components: {
    ScaleLoader,
  },
  data: () => ({
    config: {
      tenant_id: null,
      tenant_domain: null,
      client_id: null,
      client_secret: null
    },
    isLoading: false,
    sendingform: false,
  }),

  computed: {
    ...mapGetters({
      company: 'app/company',
    }),
  },

  mounted() {
    this.getConfig()
  },


  methods: {
    async getConfig() {
      this.isLoading = true
      let {data} = await axios.get('/api/v2/sharepoint-keys', {
        params: {
          company_id: this.company.id
        }
      });

      if (data && data.success && data.data) {
        this.config = data.data
      }
      this.isLoading = false
    },

    async save() {
      this.sendingform = true
      this.config.company_id = this.company.id
      let {data} = await axios.post('/api/v2/sharepoint-key', this.config)
      if (data.success) {
        this.$notify.success('save_successful')
      } else {
        this.$notify.error(data.msg)
      }
      this.sendingform = false
    }
  },
};
</script>
